import Cookies from "./Cookies";

export default class Popup {

    static init() {
        const today = new Date();
        const popups = document.querySelectorAll('.popup');
        if(popups.length > 0) {
            popups.forEach(function(popup) {
                const date = new Date(popup.dataset.date);
                if(Cookies.getCookie('popup-'+popup.dataset.id) !== 'hide' && today.getTime() < date.getTime()) {
                    popup.style.display = "block";
                }

            })
        }

        this.handlePopupClose();
    }

    static handlePopupClose() {
        const closeButtons = document.querySelectorAll('.popup__close');
        if(closeButtons.length > 0) {
            closeButtons.forEach(function(closeButton) {
                closeButton.addEventListener('click', e => {
                    const id = closeButton.parentElement.dataset.id;
                    closeButton.parentElement.style.display = 'none';
                    Cookies.setCookie('popup-'+id, 'hide', closeButton.parentElement.dataset.days);
                })
            })
        }
    }
}

